import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { PtInput, PtSelect, PtInputAndEstimate } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import ScrollArea from 'react-scrollbar';
import config from '../../../config.json'


export default class XSection extends Component {

    constructor(props) {
        super(props);
        console.log(this.props.csModel)
        const { csModel } = this.props;
        this.state = csModel.xModel;
        //console.log(this.state);
    }

    render() {

        const {
            laneWidthOptions,
            numLanesOptions,
            rtShoulderOptions,
            curbsOptions,
            ratioOptions,
            paveSloughWidthOptions,
            trtOptions,
            medianTypeOptions,
            ownerOptions
        } = DropdownLib.getDropdowns().CS_XSection;
        console.log('Owner Options for Render ', ownerOptions)
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <PtSelect label="Lane Width (ft)" options={laneWidthOptions} defaultVal={this.state.laneWidth} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="laneWidth" />

                    <PtSelect label="Number of Lanes (total)" options={numLanesOptions} defaultVal={this.state.numLanes} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="numLanes" />

                    <PtSelect label="Right Shoulder Total" options={rtShoulderOptions} defaultVal={this.state.rtShoulderTotal} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="rtShoulderTotal" />

                    <PtSelect label="Right Shoulder Paved" options={rtShoulderOptions} defaultVal={this.state.rtShoulderPaved} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="rtShoulderPaved" />

                    <PtInput label="Roadside Clearzone Width" value={this.state.roadsideClearzoneWidth} onChange={this.onInputChange} name="roadsideClearzoneWidth" disabled={this.props.disabled}
                        inputType="numberUnder100" placeholder="0" />

                    <PtInputAndEstimate inputType="year" placeholder="1900" label="Grading Year" value={this.state.gradingYear} onChange={this.onInputChange}
                        name="gradingYear" estimated={this.state.gradingYearEst} disabled={this.props.disabled} />

                    <PtSelect label="Curbs" options={curbsOptions} defaultVal={this.state.curbs} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="curbs" />

                    <PtSelect label="Inslope Ratio" options={ratioOptions} defaultVal={this.state.inslopeRatio} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="inslopeRatio" />

                    <PtSelect label="Pave Slough Width (ft)" options={paveSloughWidthOptions} defaultVal={this.state.paveSloughWidth} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="paveSloughWidth" />

                    <PtSelect label="Slough Ratio" options={ratioOptions} defaultVal={this.state.sloughRatio} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="sloughRatio" />

                    <PtSelect label="Edgeline Treatment" options={trtOptions} defaultVal={this.state.edgelineTrt} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="edgelineTrt" />

                    <PtSelect label="Centerline Treatment" options={trtOptions} defaultVal={this.state.centerlineTrt} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="centerlineTrt" />

                    <PtSelect label="Median Type" options={medianTypeOptions} defaultVal={this.state.medianType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="medianType" />

                    <PtInput label="Median Width (ft)" value={this.state.medianWidth} onChange={this.onInputChange} name="medianWidth" disabled={this.props.disabled}
                        inputType="distanceft" placeholder="0" />
                    <PtInput label="Right-of-Way (ft)" value={this.state.rightOfWay} onChange={this.onInputChange} name="rightOfWay" disabled={this.props.disabled}
                        inputType="distanceft" placeholder="0" />

                    <PtSelect label="Owner" options={ownerOptions} defaultVal={this.state.sectionOwner} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="sectionOwner" />

                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;

        //console.log(target.value);
        //console.log(target.name);

        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;

        //console.log(name);
        //console.log(value);

        this.props.triggerNeedSave();

        this.setState({ [name]: value === '' ? null : (name == 'roadsideClearzoneWidth') ? parseInt(value) : parseFloat(value) });
    }

    getAgencyType = () => {
        const { ownerOptions
        } = DropdownLib.getDropdowns().CS_XSection

        fetch(`${config.server}/getagencies/`)
            .then(response => response.json())
            .then(data => {
                data.map((agency, i) => {
                    if (agency.Id === this.props.agencyId && this.props.agencyId !== -1 && this.props.csModel.route.id === -1)
                        ownerOptions.map((owner) => {
                            if (owner.label.toLowerCase() === agency.Type.toLowerCase())
                                this.setState({
                                    sectionOwner: owner.value
                                })

                        })

                    //ow

                })

            })
    }

    componentDidMount() {
        this.getAgencyType()
    }

    componentDidUpdate() {
        this.props.csModel.xModel = this.state;
    }

}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/xsection.js